var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRdp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C11.88 0 23.76 0 36 0 C36.1875 9.6875 36.1875 9.6875 36.20776367 12.71362305 C36.38395426 18.29197956 36.38395426 18.29197956 39.51171875 22.83203125 C40.33285156 23.54746094 41.15398438 24.26289062 42 25 C42.91239336 28.43489266 42.68357774 31.52514651 42 35 C40.125 38.125 40.125 38.125 37 40 C33.52201009 40.68419474 30.47370016 40.72321298 27 40 C23.875 37.6875 23.875 37.6875 22 35 C22 34.01 22 33.02 22 32 C17.05 32 12.1 32 7 32 C7 31.01 7 30.02 7 29 C8.98 29 10.96 29 13 29 C13 28.01 13 27.02 13 26 C8.71 26 4.42 26 0 26 C0 17.42 0 8.84 0 0 Z ",
    fill: "#DBDDDC",
    transform: "translate(6,8)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.29 0 8.58 0 13 0 C15.82523551 6.86128624 17.41426694 13.75093459 19 21 C12.73 21 6.46 21 0 21 C0 14.07 0 7.14 0 0 Z ",
    fill: "#303F9F",
    transform: "translate(8,10)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 5.94 19 11.88 19 18 C12 20 12 20 6 21 C4.02 14.07 2.04 7.14 0 0 Z ",
    fill: "#7885CA",
    transform: "translate(21,10)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C11.88 0 23.76 0 36 0 C36 6.6 36 13.2 36 20 C35.34 20 34.68 20 34 20 C34 14.06 34 8.12 34 2 C23.44 2 12.88 2 2 2 C2 8.93 2 15.86 2 23 C9.26 23 16.52 23 24 23 C23.34 25.97 22.68 28.94 22 32 C17.05 32 12.1 32 7 32 C7 31.01 7 30.02 7 29 C8.98 29 10.96 29 13 29 C13 28.01 13 27.02 13 26 C8.71 26 4.42 26 0 26 C0 17.42 0 8.84 0 0 Z ",
    fill: "#B0BEC5",
    transform: "translate(6,8)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.97 0 5.94 0 9 0 C9 1.98 9 3.96 9 6 C4.05 6 -0.9 6 -6 6 C-6 5.01 -6 4.02 -6 3 C-4.02 3 -2.04 3 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#8FA3AD",
    transform: "translate(19,34)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.814375 0.763125 1.62875 1.52625 1.4375 2.3125 C0.77180827 5.08967375 0.77180827 5.08967375 2 8 C0.68 7.34 -0.64 6.68 -2 6 C-2 2 -2 2 0 0 Z ",
    fill: "#49964D",
    transform: "translate(41,32)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0.99 1.98 0.99 4 2 C4 3.32 4 4.64 4 6 C2.02 6.99 2.02 6.99 0 8 C0.185625 7.236875 0.37125 6.47375 0.5625 5.6875 C1.22819173 2.91032625 1.22819173 2.91032625 0 0 Z ",
    fill: "#49964D",
    transform: "translate(33,36)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRdp);
export default __webpack_public_path__ + "static/media/rdp.f76e9a836320a9da0e5a75856cf2d371.svg";
export { ForwardRef as ReactComponent };